import type { FC, PropsWithChildren } from "react";
import React from "react";

import type { LoggerContract } from "@core/foundation/logger";

import { LoggerContext } from "../contexts/logger/context.ts";

interface LoggerProviderProps {
  readonly logger: LoggerContract;
}

export const LoggerProvider: FC<PropsWithChildren<LoggerProviderProps>> = ({
  children,
  logger,
}) => (
  <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
);
